import toggleCancelledDialog from "./toggleCancelledDialog";
import addScheduledTripDialog from "./AddScheduledTripDialog";
// import editScheduledTripDialog from "./EditScheduledTripDialog";

const ScheduledTripListDialogs = (SystemData, apiSitePrefix, year, month, extraKeys, handleAdd, handleUpdate, handledDelete, formatChars, classes, ownerDepartment = "COMMERCIAL") => {
  const toggleCancelled = toggleCancelledDialog(SystemData, handleUpdate, extraKeys);
  const {Dialog: AddScheduledTripDialog, open: openAddSchedule, close: closeAddSchedule} = addScheduledTripDialog(SystemData, apiSitePrefix, extraKeys, handleAdd, formatChars, classes, ownerDepartment);
  // const {Dialog: EditScheduledTripDialog, open: openEditSchedule, close: closeEditSchedule} = editScheduledTripDialog(SystemData, apiSitePrefix, extraKeys, handleUpdate, formatChars, classes, ownerDepartment);

  return {
    toggleCancelled,
    AddScheduledTripDialog, openAddSchedule, closeAddSchedule,
    // EditScheduledTripDialog, openEditSchedule, closeEditSchedule,
  }
}


export default ScheduledTripListDialogs;
